<template>
  <div>
    <!-- NAVBAR -->
    <my-navbar :controller="controller" />

    <!-- HEADER -->
    <div class="header bg-gradient-dark pb-8 pt-5 pt-md-8">
      <div class="container-fluid">
        <div class="header-body">
          <div class="row">
            <!-- CONTENIDO HEADER -->
            <div class="col-lg-7 col-md-10">
              <h1 class="display-3 text-white">Búsqueda de Avisos</h1>
              <p
                class="text-white mt-0 mb-5"
              >Para comenzar, escribe uno o más parámetros de búsqueda.</p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- CONTENT -->
    <div class="container-fluid mt--7">
      <div class="row">
        <div class="col">
          <!-- COMPONENTE PRINCIPAL -->
          <div class="row">
            <div class="col-lg-12">
              <div class="card p-2 mb-3">
                <p class="m-0 text-sm text-muted">
                  <i class="fa fa-info"></i> Solo se mostrarán las primeras 100 coincidencias.
                </p>
                <form class="form-inline" @submit.prevent="handleSearch">
                  <input
                    type="text"
                    class="form-control my-2 mr-sm-2"
                    id="inlineFormInputName2"
                    placeholder="Nombre y Apellido"
                    v-model="querySearch.nombre"
                    name="nombre"
                    v-validate="'min:2'"
                    maxlength="50"
                    :disabled="loading"
                  />
                  <input
                    type="text"
                    class="form-control my-2 mr-sm-2"
                    id="inlineFormInputName2"
                    placeholder="RUT"
                    v-model="querySearch.rut"
                    name="rut"
                    :disabled="loading"
                  />
                  <input
                    type="email"
                    class="form-control my-2 mr-sm-2"
                    id="inlineFormInputName2"
                    placeholder="Email"
                    v-model="querySearch.email"
                    name="email"
                    v-validate="'email'"
                    :disabled="loading"
                  />
                  <input
                    type="text"
                    class="form-control my-2 mr-sm-2"
                    id="inlineFormInputName2"
                    placeholder="Teléfono"
                    v-model="querySearch.telefono"
                    name="telefono"
                    v-validate="'min:9'"
                    :disabled="loading"
                  />
                  <input
                    type="text"
                    class="form-control my-2 mr-sm-2"
                    id="inlineFormInputName2"
                    placeholder="Patente o Código Auto"
                    v-model="querySearch.patenteCodigo"
                    name="patenteCodigo"
                    v-validate="'min:5|max:15'"
                    :disabled="loading"
                  />

                  <select
                    name
                    id
                    class="form-control my-2 mr-sm-2"
                    v-model="querySearch.actuales"
                    :disabled="loading"
                  >
                    <option value="1">Actuales</option>
                    <option value="0">Históricos</option>
                  </select>

                  <button type="submit" class="btn btn-primary mb-2 mt-1" :disabled="loading">
                    <i class="fa fa-search"></i>
                    <span v-text="loading ? 'Buscando...':'Buscar'">Buscar</span>
                  </button>
                  <button
                    type="button"
                    :disabled="loading"
                    v-if="search"
                    class="btn btn-secondary mt-1 mb-2 ml-2"
                    @click="resetSearch"
                  >Limpiar</button>
                </form>
                <div class="text-xs text-danger pl-3">
                  <div class="mb-1">{{ errors.first('nombre') }}</div>
                  <div class="mb-1">{{ errors.first('email') }}</div>
                  <div
                    v-if="querySearch.rut.trim().length > 0 && !isRut"
                    class="mb-1"
                  >El RUT ingresado es inválido</div>
                  <div class="mb-1">{{ errors.first('telefono') }}</div>
                  <div class="mb-1">{{ errors.first('patenteCodigo') }}</div>
                </div>
              </div>
              <div v-if="loading" class="card card-body shadow p-0" style="min-height: 200px;">
                <my-spinner :loading="loading" />
              </div>
              <div v-show="!loading && search" class="card shadow">
                <div class="card-header">
                  Resultados de búsqueda
                  <br />
                  <small
                    class="text-muted"
                  >Se ha{{resultados.length > 1 ? 'n':''}} encontrado ({{resultados.length}}) coincidencia{{resultados.length > 1 ? 's':''}}</small>
                </div>
                <div class="card-body shadow p-0">
                  <div v-if="error" class="alert alert-danger p-2 d-inline-block m-2">
                    <i class="fa fa-warning"></i> Error al consultar datos — Reintenta nuevamente.
                  </div>
                  <div
                    v-if="resultados.length == 0"
                    class="search-result p-2 text-muted"
                  >No se encontraron resultados</div>
                  <div
                    class="search-result"
                    v-for="(result, index) in  paginated('resultados')"
                    :key="index"
                  >
                    <div class="search-header p-2 pl-4">
                      <h4 class="m-0 text-primary text-capitalize">
                        {{result.nombre ? result.nombre.toString().toLowerCase() : result.nombre}} {{result.apellido ? result.apellido.toString().toLowerCase(): result.apellido}}
                        <small
                          class="text-xs text-muted"
                        ></small>
                      </h4>
                      <p
                        class="m-0 text-xs text-muted text-uppercase"
                      >RUT {{result.rut}}-{{result.dv}}</p>
                      <p class="m-0 mb-2 text-xs text-lowercase">{{result.email}}</p>
                      <button
                        data-toggle="collapse"
                        :data-target="'#collapseResult'+index"
                        aria-expanded="false"
                        :aria-controls="'collapseResult'+index"
                        class="btn btn-sm btn-secondary"
                      >
                        <i class="fa fa-plus-circle text-success"></i> Publicaciones
                      </button>
                    </div>
                    <div class="collapse search-content px-3 mb-3" :id="'collapseResult'+index">
                      <div class="table-responsive">
                        <table class="table table-hover">
                          <thead class="bg-secondary">
                            <tr>
                              <!-- <th>Acción ID</th> -->
                              <th>Código Auto</th>
                              <th>Vehículo</th>
                              <th>Patente</th>
                              <th class="text-right">Precio</th>
                              <th>Publicación / Retiro</th>
                              <th>Ciudad / Comuna</th>
                              <th>Dirección IP</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr
                              v-for="(post, postIndex) in result.acciones"
                              :key="'post_'+postIndex"
                            >
                              <!-- <td>{{post.id}}</td> -->
                              <td>{{post.cod_auto}}</td>
                              <td>
                                <h4
                                  class="m-0 text-primary text-uppercase"
                                >{{post.marca}} {{post.modelo}}</h4>
                                <p class="m-0 text-xs">{{post.agno}} - Versión {{post.version}}</p>
                              </td>
                              <td class="text-uppercase">{{post.patente ? post.patente : '-'}}</td>
                              <td class="text-right">{{post.precio | formatCurrency}}</td>
                              <td class="text-capitalize text-xs">
                                <div>
                                  <i class="fa fa-arrow-up text-success text-xs"></i>
                                  {{post.fecha | formatDate}}
                                </div>
                                <div>
                                  <i class="fa fa-arrow-down text-danger text-xs"></i>
                                  {{post.fecha_retiro | formatDate}}
                                </div>
                              </td>
                              <td class="text-capitalize">
                                <p
                                  class="m-0 text-xs"
                                >{{post.ciudad ? post.ciudad : 'No especificado'}}</p>
                                <p
                                  class="m-0 text-xs text-muted"
                                >{{ post.comuna ? post.comuna : 'No especificado' }}</p>
                              </td>
                              <td>{{post.ip == '::1' || post.ip == null ? '-': post.ip}}</td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="card-footer">
                  <paginate
                    ref="paginator"
                    v-if="shown"
                    name="resultados"
                    :list="resultados"
                    :per="10"
                  ></paginate>
                  <paginate-links
                    :async="true"
                    for="resultados"
                    :show-step-links="true"
                    :limit="5"
                    class="v-paginate v-paginate-justify"
                    :hide-single-page="true"
                  ></paginate-links>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <b-modal
      ref="detailsModal"
      no-close-on-esc
      hide-footer
      title="Detalles del Vendedor"
      no-close-on-backdrop
    >
      <modal-form :vendedor="vendedor" />
      <div class="text-right">
        <b-button class="mt-3" variant="outline-danger" @click="hideModal">Cerrar</b-button>
      </div>
    </b-modal>
  </div>
</template>
<script>
import utils from "@/helpers/utils";
import ModalForm from "./ModalForm";
import { Validator } from "vee-validate";
import validation from "@/helpers/validations";
import sysMsg from "@/helpers/system.message";
import avisoServices from "@/services/avisos.services";
import globalServices from "@/services/globals.services";
export default {
  name: "Historicos",
  components: { ModalForm },
  data() {
    return {
      controller: {
        title: "Operaciones",
        mainRouter: "/operaciones/avisos/historicos"
      },
      shown: false,
      loading: false,
      search: false,
      error: false,
      paginate: ["resultados"],
      vendedor: {},
      querySearch: {
        nombre: "",
        rut: "",
        telefono: "",
        patenteCodigo: "",
        email: "",
        actuales: "1"
      },
      resultados: []
    };
  },
  computed: {
    invalidSearch() {
      const { nombre, rut, telefono, patenteCodigo, email } = this.querySearch;
      return (
        nombre.trim().length == 0 &&
        rut.trim().length == 0 &&
        telefono.trim().length == 0 &&
        patenteCodigo.trim().length == 0 &&
        email.trim().length == 0
      );
    },
    isRut() {
      return validation.rut.isValid(this.querySearch.rut);
    }
  },
  filters: {
    formatDate(str) {
      if (!str || str == null) return "No especificado.";

      return utils.formatDateTime(str);
    },
    formatCurrency(str) {
      if (!str) return;

      return utils.currency(str);
    }
  },
  methods: {
    showModal(index) {
      this.vendedor = this.resultados[index];
      this.$refs["detailsModal"].show();
      /* globalServices.filters.ciudades(this.vendedor.ciudad).then(response => {
        console.log(response.data);
      }); */
    },
    hideModal() {
      this.$refs["detailsModal"].hide();
    },
    resetSearch() {
      this.search = false;
      this.resultados = [];
      this.querySearch = {
        nombre: "",
        rut: "",
        telefono: "",
        patenteCodigo: "",
        email: "",
        actuales: "1"
      };
    },
    handleSearch() {
      if (this.invalidSearch) {
        sysMsg.getMessage(
          "Debes indicar al menos 1 parámetro de búsqueda.",
          "error"
        );
        return;
      }

      if (this.querySearch.rut.trim().length > 0 && !this.isRut) return;

      this.$validator.validate().then(valid => {
        if (valid) {
          this.startSearch();
        }
      });
    },
    sanitizeRUT(str) {
      return str.replace(/[.-]|[k]/gi, "").substr(0, 8);
    },
    startSearch() {
      const {
        nombre,
        rut,
        telefono,
        patenteCodigo,
        email,
        actuales
      } = this.querySearch;

      this.loading = true;
      this.search = true;
      this.resultados = [];
      avisoServices.historical
        .getSearch({
          nombre,
          rut: this.sanitizeRUT(rut),
          telefono,
          patenteCodigo,
          email,
          actuales: actuales == "1"
        })
        .then(response => {
          this.error = false;
          let tmp = response.data.respuesta.particulares;
          this.resultados = tmp == null ? this.resultados : tmp;
          this.paginate.resultados.page = 0;
          /* if (this.$refs.paginator) {
            this.$refs.paginator.goToPage(1);
          } */
        })
        .catch(error => {
          this.error = true;
          sysMsg.getResponseMessage(error.response);
        })
        .finally(() => {
          this.loading = false;
          this.shown = true;
        });
    }
  },
  created() {
    this.$validator.localize("es");
  }
};
</script>

<style lang="scss" scoped>
.search-result {
  .search-header {
    transition: all ease-in-out 0.2;
    &:hover,
    &:focus {
      background: #f5f8ff;
    }
  }

  .search-content {
    background: #f5f8ff;
  }
}
</style>
